<template lang="pug">
.rounded-md.bg-red-50.p-4
  .flex
    .flex-shrink-0
      svg.h-5.w-5.text-red-400(viewbox='0 0 20 20' fill='currentColor')
        path(fill-rule='evenodd' d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z' clip-rule='evenodd')
    .ml-3.flex-1(class='md:flex md:justify-between')
      p.text-sm.leading-5.text-red-700
        slot
      p.mt-3.text-sm.leading-5(v-if="displaySupport" class='md:mt-0 md:ml-6')
        a.whitespace-no-wrap.font-medium.text-red-700.transition.ease-in-out.duration-150(href='https://support.streamify.io' class='hover:text-red-600')
          | Support &rarr;
</template>

<script>
export default {
  props: ['displaySupport'],
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 1.25rem;
  line-height: 1.5rem;
  margin-bottom: .5rem;
}
</style>
